import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { getuserdata } from "../actions/userActions";
import intl from 'react-intl-universal';

import Card from '@mui/material/Card';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import CameraIndoorIcon from '@mui/icons-material/CameraIndoor';
import PersonIcon from '@mui/icons-material/Person';
import EqualizerIcon from '@mui/icons-material/Equalizer';
import MediationIcon from '@mui/icons-material/Mediation';
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';

import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import CheckIsLogin from '../CheckIsLogin';

class DashBoard extends Component {

 

    render () {  
      
      
      const { singeluserdata } = this.props;
      const { userrights } = this.props

      let userrole = "";
        let userrolearray = this.props.userrole
        if (this.props.userrole !== undefined) {
          userrole = userrolearray[0]
      }
      
      if (this.props.userrole === undefined) {
        return (
          <Fragment>Loading</Fragment>
        )
      }


    if (this.props.userrole !== undefined) {
    return (
           
    <Fragment>
      <CheckIsLogin />
        <Grid container component="main" sx={{ height: '100vh' }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={6}
          sx={{
            backgroundImage: 'url(../images/mainpic.jpg)',
            backgroundRepeat: 'no-repeat',
            backgroundColor: (t) =>
              t.palette.mode === 'light' ? t.palette.grey[50] : t.palette.grey[900],
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }}
        />
        <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
            }}
          >     
          <Typography gutterBottom variant="h5" component="h2">
          Webex Recordings
          </Typography>
          <p className="center">{intl.get('DASH_WILLKOMMEN')}  <strong>{singeluserdata.firstName} {singeluserdata.lastName}</strong>!<br />
          </p>{intl.get('DASH_OPTION')}
          <hr />
          <Grid container spacing={8} justify="center">
          {userrights.recordings === 1  &&
              <Grid item  xs={12} sm={6} md={6} >
                <Card sx={{ height: '100%', display: 'flex', flexDirection: 'column',  alignItems: 'center' }}>
                 
                  <CardContent className="center" sx={{ flexGrow: 1 }}>
                  <CameraIndoorIcon fontSize="large"/>
                    <Typography gutterBottom variant="h5" component="h2">
                        {intl.get('RECORDINGS')}
                    </Typography>
                    <Typography>
                    {intl.get('DASH_RECORDINGS_DESC')}
                    </Typography>
                  </CardContent>
                  <CardActions className="center">
                  <Typography sx={{ minWidth: 100 }}><Link className ="dashbutton" to="/recordings">{intl.get('RECORDINGS')}<ArrowForwardIosIcon /></Link></Typography>
                  </CardActions>
                </Card>
              </Grid>
            }
              {userrights.auditLog === 1 &&
              <Grid item  xs={12} sm={6} md={6}>
                <Card
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                 
                  <CardContent sx={{ flexGrow: 1 }} className="center">
                  <MediationIcon fontSize="large"/>
                    <Typography gutterBottom variant="h5" component="h2">
                    {intl.get('AUDITLOG')}
                    </Typography>
                    <Typography>
                    {intl.get('DASH_AUDITLOG_DESC')}
                    </Typography>
                  </CardContent>
                  <CardActions className="center">
                  <Typography sx={{ minWidth: 100 }}><Link className ="dashbutton" to="/activities">{intl.get('AUDITLOG')} <ArrowForwardIosIcon /></Link></Typography>
                    
                  </CardActions>
                </Card>
              </Grid>
              }

              {userrights.systemLog === 1 &&
              <Grid item  xs={12} sm={6} md={6}>
                <Card
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} 
                >
                 
                  <CardContent sx={{ flexGrow: 1 }} className="center">
                  <EqualizerIcon fontSize="large"/>
                    <Typography gutterBottom variant="h5" component="h2">
                    {intl.get('SYSTEMLOG')}
                    </Typography>
                    <Typography>
                      {intl.get('DASH_SYSTEMLOG_DESC')}
                    </Typography>
                  </CardContent>
                  <CardActions className="center">
                  <Typography sx={{ minWidth: 100 }}><Link className ="dashbutton" to="/logs">{intl.get('SYSTEMLOG')} <ArrowForwardIosIcon /></Link></Typography>
                  </CardActions>
                </Card>
              </Grid>
            }

          {userrights.userManagement === 1 &&
              <Grid item  xs={12} sm={6} md={6}>
                <Card
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }} 
                >
                 
                  <CardContent sx={{ flexGrow: 1 }} className="center">
                  <PeopleAltIcon fontSize="large"/>
                    <Typography gutterBottom variant="h5" component="h2">
                    {intl.get('USERMANAGEMENT')}
                    </Typography>
                    <Typography>
                      {intl.get('DASH_USERMANAGEMENT_DESC')}
                    </Typography>
                  </CardContent>
                  <CardActions className="center">
                  <Typography sx={{ minWidth: 100 }}><Link className ="dashbutton" to="/user">{intl.get('USERMANAGEMENT')} <ArrowForwardIosIcon /></Link></Typography>
                  </CardActions>
                </Card>
              </Grid>
            }





              <Grid item  xs={12} sm={6} md={6}>
                <Card
                  sx={{ height: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}
                >
                 
                  <CardContent sx={{ flexGrow: 1 }} className="center">
                  <PersonIcon fontSize="large"/>
                    <Typography gutterBottom variant="h5" component="h2">
                    {intl.get('BENUTZEREINSTELLUNGEN')}
                    </Typography>
                    <Typography>
                    {intl.get('DASH_BENUTZEREINSTELLUNGEN_DESC')}
                    </Typography>
                  </CardContent>
                  <CardActions className="center">
                  <Typography sx={{ minWidth: 100 }}><Link className ="dashbutton" to="/account">{intl.get('BENUTZEREINSTELLUNGEN')} <ArrowForwardIosIcon /></Link></Typography>
                  
                  </CardActions>
                </Card>
              </Grid>
            
          </Grid>
       
          </Box>
        </Grid>
      </Grid>
    </Fragment>
        )
    }
  } 


}

const mapStateToProps = state => ({
    state: state,
    apitoken: state.gettocken.apitoken,
    userrole: state.getuserdata.userme.roles,
    singeluserdata: state.getuserdata.userme,
    userrights: state.getuserdata.userrights
  });

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        getuserdata: getuserdata
      }, dispatch);
  }

export default connect(mapStateToProps,mapDispatchToProps)(DashBoard);